import { useDispatch, useSelector } from 'react-redux';
import React, { useState } from 'react';
import lineEndpoint from '../../../../api/services/lineEndpoint';
import notification from '../../../../config/notification';
import { URLS } from '../../../../config/urls';
import { clearSelectedLine } from '../../../../store/slices/line';
import { errorHandler } from '../../../../utils/errorHandler';
import Dialog from '@material-ui/core/Dialog';
import { FastField, Form, Formik } from 'formik';
import { activationLineValidationSchema } from '../../form-configs/validation-schemas';
import Loading from '../../../../layouts/Loading';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import DialogContent from '@material-ui/core/DialogContent';
import Grid from '@material-ui/core/Grid';
import CustomTextField from '../../components/TextField';
import CustomDateField from '../../components/DateField';
import SaveBox from '../../components/SaveBox';
import { generatePath, useHistory } from 'react-router-dom';

const LineActivateModal = ({ open, onClose, title, selectedLine }) => {
    const history = useHistory();
    const dispatch = useDispatch();

    const [loadingInactivation, setLoadingInactivation] = useState(false);

    const activeUser = useSelector((state) => state.auth.registrationInfo);
    const isStrip = useSelector((state) => state.line.isStrip);

    const isActive = selectedLine?.boAtivo;
    const today = new Date().toISOString();

    const inactivateInitialValues = {
        cdLinha: selectedLine?.cdLinha,
        deMotivo: '',
        deObservacao: '',
        dtCadastro: today,
    };

    const renderJustifyLabel = () => {
        return isActive ? 'Motivo da inativação' : 'Motivo da ativação';
    };

    const handleSubmitInactivation = async (vls) => {
        const prepareData = {
            ...vls,
            boAtivar: !isActive,
            cdUsuarioResponsavel: activeUser.cdUsuario,
        };
        try {
            setLoadingInactivation(true);
            const response = await lineEndpoint.inactivateLine(prepareData);
            if (response.status === 200) {
                notification('Alteração salva com sucesso', {
                    toastId: 'SUCCESSFUL_SAVE_ACTIVATION',
                    type: 'success',
                });
            }
            onClose();
            const params = {};
            if (isStrip) params.isStrip = 'strip';
            history.push(generatePath(URLS.LINES_MANAGE, params));
            dispatch(clearSelectedLine());
        } catch (error) {
            errorHandler(error.response?.status, error.response?.data?.message);
        } finally {
            setLoadingInactivation(false);
        }
    };

    return (
        <Dialog fullWidth maxWidth="md" open={open} onClose={onClose} scroll="body">
            <Formik
                validateOnBlur
                enableReinitialize
                validationSchema={activationLineValidationSchema}
                initialValues={inactivateInitialValues}
                onSubmit={handleSubmitInactivation}>
                {(formProps) => (
                    <Form>
                        {loadingInactivation && <Loading />}
                        <DialogTitle onClose={onClose} disableTypography>
                            <Typography color="secondary" variant="subtitle2">
                                {title}
                            </Typography>
                        </DialogTitle>
                        <DialogContent dividers>
                            <Grid container spacing={3}>
                                <Grid item xs={12} sm={8}>
                                    <FastField
                                        component={CustomTextField}
                                        disabled
                                        label="Linha"
                                        value={selectedLine?.deDescricao}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <FastField component={CustomDateField} label="Data" name="dtCadastro" />
                                </Grid>
                                <Grid item xs={12}>
                                    <FastField
                                        component={CustomTextField}
                                        label={renderJustifyLabel()}
                                        name="deMotivo"
                                        multiline
                                        rows={2}
                                        inputProps={{
                                            maxLength: 2000,
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <FastField
                                        component={CustomTextField}
                                        label="Observação"
                                        name="deObservacao"
                                        multiline
                                        minRows={4}
                                        inputProps={{
                                            maxLength: 2000,
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <SaveBox
                                        onCancel={onClose}
                                        onSave={formProps.handleSubmit}
                                        removeSpacing
                                        firstButtonLabel={'Voltar'}
                                    />
                                </Grid>
                            </Grid>
                        </DialogContent>
                    </Form>
                )}
            </Formik>
        </Dialog>
    );
};

export default LineActivateModal;
